import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
// @mui
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import Iconify from '../../components/Iconify';
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

export default function ScoutAddToPoolDialogButton({ profile, selectNextCrew }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nextCrew, setNextCrew] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const stopPropagationForTab = (e) => {
    if (e.key === "Tab") {
      e.stopPropagation();
    }
  };

  const closeAndReload = () => {
    setOpen(false);
    selectNextCrew(nextCrew);
  };

  const accept = async () => {
    try {
      setLoading(true);
      const companyId = user?.employee.company?.[0]?.id;
      if (!profile?.id || !companyId) {
        enqueueSnackbar("요청이 실패하였습니다. 관리자에 문의해주세요.", { variant: 'warning' });
        return ;
      }
      const response = await axios.post(`/api/company/${companyId}/scout/${profile?.id}/accept/`);
      setNextCrew(response.data.next_crew);
      setLoading(false);
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 400 && error.response.data && error.response.data.message) {
        enqueueSnackbar(error.response.data.message, { variant: 'warning' });
      } else {
        enqueueSnackbar("요청이 실패하였습니다. 관리자에 문의해주세요.", { variant: 'warning' });
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      accept();
    } else {
      setLoading(false);
      setNextCrew(null);
    }
  }, [open]);

  return (
    <>
    <LoadingButton
      fullWidth
      variant="contained"
      startIcon={<Iconify icon="eva:plus-fill" sx={{ width: 20, height: 20 }} />}
      size={smUp ? "medium" : "small"}
      onClick={() => setOpen(true)}
      disableRipple
    >
      인재풀에 추가
    </LoadingButton>
    <Dialog
      open={open}
      fullWidth
      maxWidth="dg"
      onKeyDown={stopPropagationForTab}
    >
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        {loading ? (
          <Typography variant="h5" paragraph>
            {profile?.nickname} 크루를 인재풀에 저장하고 있습니다. 
          </Typography>
        ) : (
          <Typography variant="h5" paragraph>
            {profile?.nickname} 크루가 인재풀에 저장되었습니다. 
          </Typography>
        )}
        {!loading && (
          <Typography>
            크루에게 커피챗을 제안해보세요!
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <LoadingButton
          variant="contained"
          size="large"
          sx={{ px: 4 }}
          fullWidth={!smUp}
          onClick={closeAndReload}
          loading={loading}
        >
          확인했어요
        </LoadingButton>
      </DialogActions>
    </Dialog>
    </>
  )
};
